var $ = require('jQuery');
var OpenRounds = require('../../lib/open-rounds.js');

module.exports = function() {
    new OpenRounds();

    // Filtertron
    $('.filtertron').filtertron('entries', {
        expander: '#filtertronExpander'
    });

    // Score set selector
    $('#scoreSetSelector').on("change", function() {
        var data = 'score-set=' + $(this).val();
        var url  = $(this).data('url');
        $.pjax({url: url, data: data, container: '#pjaxContainer', method: 'GET'});
    });
};
